module.exports = __webpack_public_path__ + "static/assets/bde0d6784df470f00da33594bf2e5140.png";